<template>
  <div>
    <div class="card mb-0 shadow" v-if="!editar_encaminhamento">
      <div class="card-body">
        <div class="tab-content">
          <div class="animate__animated animate__fadeIn">
            <div class="row">
              <div class="col-12">
                <h4 class="font-weight-bold">Encaminhamentos</h4>
              </div>
              <div class="col-md-12">
                <div
                  v-if="!novo_encaminhamento"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                          mb-4
                        "
                      >
                        <div>
                          <button
                            class="btn btn-sm btn-primary"
                            @click="novo_encaminhamento = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                          <button
                            class="btn btn-sm btn-primary"
                            @click.prevent="$bvModal.show('relacionar-model')"
                          >
                            <i class="mdi mdi-connection" />
                            {{ $t("Relacionar com um existente") }}
                          </button>
                        </div>
                        <div>
                          <div class="input-group mb-3">
                            <b-input
                              :placeholder="$t('Type to search')"
                              class="form-control search-input"
                              type="text"
                              v-model="search"
                              v-on:change="getEncaminhamentos"
                              aria-describedby="input-search"
                            />
                            <div class="input-group-append" role="button">
                              <span class="input-group-text" id="input-search"
                                ><i class="fas fa-search search-icon"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <load mode="table" v-if="loadingEncaminhamentos" />
                    <div class="col-12" v-else>
                      <ListEncaminhamentos
                        :itens="EncaminhamentosList"
                        :pagination="pagination"
                        :page.sync="page"
                        :porpagina.sync="perPage"
                        @changePage="changePage"
                        @reload="getEncaminhamentos"
                        @editar="
                          encaminhamentoSelected = $event;
                          editar_encaminhamento = true;
                        "
                      />
                    </div>
                  </div>
                </div>
                <NovoEncaminhamento
                  v-else
                  :familia="familia"
                  :morph="{
                    id: violacaodedireito.id,
                    type: 'ViolenciaViolacaoDireito',
                  }"
                  @voltar="novo_encaminhamento = false"
                  @reload="
                    getEncaminhamentos();
                    novo_encaminhamento = false;
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditarEncaminhamento
      v-else
      :morph="true"
      :morph-encaminhamento-id="encaminhamentoSelected"
      @voltar="editar_encaminhamento = false"
    />
    <ModalRelacionar
      table="encaminhamentos"
      text="Encaminhamento"
      :item-id="violacaodedireito.id"
      :familia-id="familia.id"
      label="Digite ou selecione o Protocolo"
      @reload="getEncaminhamentos"
    />
  </div>
</template>
<script>
import NovoEncaminhamento from "../../../../../../Encaminhamento/Resources/assets/js/Add";
import EditarEncaminhamento from "../../../../../../Encaminhamento/Resources/assets/js/Edit";
import ModalRelacionar from "../ModalRelacionar";
import ListEncaminhamentos from "./lista/ListEncaminhamentos";

export default {
  components: {
    NovoEncaminhamento,
    EditarEncaminhamento,
    ModalRelacionar,
    ListEncaminhamentos,
  },
  props: ["violacaodedireito"],
  name: "Encaminhamentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Encaminhamentos"),
    };
  },
  data() {
    return {
      familia: {},
      encaminhamentoSelected: "",
      editar_encaminhamento: false,
      novo_encaminhamento: false,
      TipoEncaminhamentosList: [],
      EncaminhamentosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingEncaminhamentos: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  mounted() {
    // this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getEncaminhamentos();
  },
  methods: {
    getEncaminhamentos() {
      this.loadingEncaminhamentos = true;
      axios
        .get("api/dashboard/encaminhamentos", {
          params: {
            id: this.$route.query.familia_id,
            morph_type: "ViolenciaViolacaoDireito",
            morph_id: this.violacaodedireito.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.EncaminhamentosList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getEncaminhamentos();
          } else {
            this.loadingEncaminhamentos = false;
          }
        })
        .catch(() => {
          this.loadingEncaminhamentos = false;
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getEncaminhamentos();
      }
    },
    redirectEncaminhamento(id) {
      this.$router.push({
        path: `/dashboard/encaminhamentos/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.query.familia_id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
  },
};
</script>

